import {
    SET_WEEK_COUNT,
    SET_WEEK_START,
    GET_USERS,
    GET_RAW_JOBPOSTINGS,
    SET_ACTIVE_JOBPOSTING,
    SET_CLICKED_EVENT_SEGMENT,
    GET_DEPARTMENTS,
    GET_AREAS,
    SET_JOBPOSTING_DATES,
    SET_ARRANGED_JOBPOSTINGS,
    SET_COPY_PASTE_EVENT,
    SET_TRACK_ID,
    GET_EQUIPMENT,
    GET_VEHICLES,
    GET_ROSTER_IS_LOCKED,
    GET_PLANNER_DETAILS,
    SET_SELECTED_JOBPOSTING_ID,
    SET_SELECTED_DEPARTMENT,
    SET_SELECTED_AREA,
} from "./types";
import moment from "moment";

const INITIAL_STATE = {
    weekCount: 1,
    copyPasteEvent: false,
    weekStart: moment().startOf("isoWeek").toDate(),
    users: false,
    usersRequesting: false,
    rawJobpostings: false,
    rawJobpostingsRequesting: false,
    activeJobposting: false,
    clickedEventSegment: false,
    arrangedJobpostings: false,
    selectedJobpostingID: false,
    isLocked: false,
    selected_department: "all_departments",
    selected_area: "all_areas",
    departments: false,
    areas: false,
    vehicles: false,
    equipment: false,
    plannerDetails: false,
    trackID: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_SELECTED_JOBPOSTING_ID: {
            return {
                ...state,
                selectedJobpostingID: action.payload,
            };
        }
        case SET_SELECTED_DEPARTMENT: {
            return {
                ...state,
                selected_department: action.payload,
            };
        }
        case SET_SELECTED_AREA: {
            return {
                ...state,
                selected_area: action.payload,
            };
        }
        case SET_ARRANGED_JOBPOSTINGS: {
            return {
                ...state,
                arrangedJobpostings: { ...action.payload },
            };
        }
        case SET_JOBPOSTING_DATES: {
            return {
                ...state,
                jobpostings: { ...action.payload },
            };
        }
        case SET_COPY_PASTE_EVENT: {
            return {
                ...state,
                copyPasteEvent: action.payload,
            };
        }
        case SET_TRACK_ID: {
            return {
                ...state,
                trackID: action.payload,
            };
        }
        case SET_CLICKED_EVENT_SEGMENT: {
            return {
                ...state,
                clickedEventSegment: action.payload,
            };
        }
        case SET_ACTIVE_JOBPOSTING: {
            return {
                ...state,
                activeJobposting: action.payload,
            };
        }
        case SET_WEEK_COUNT: {
            return { ...state, weekCount: action.payload };
        }
        case SET_WEEK_START: {
            return { ...state, weekStart: action.payload };
        }
        case GET_RAW_JOBPOSTINGS.REQUEST: {
            return { ...state, rawJobpostingsRequesting: true };
        }
        case GET_RAW_JOBPOSTINGS.FAIL: {
            return {
                ...state,
                rawJobpostings: false,
                rawJobpostingsRequesting: false,
            };
        }
        case GET_RAW_JOBPOSTINGS.SUCCESS: {
            return {
                ...state,
                rawJobpostings: action.payload,
                rawJobpostingsRequesting: false,
            };
        }
        case GET_VEHICLES.REQUEST: {
            return { ...state, requesting: true };
        }
        case GET_VEHICLES.FAIL: {
            return {
                ...state,
                vehicles: false,
                requesting: false,
            };
        }
        case GET_VEHICLES.SUCCESS: {
            return {
                ...state,
                vehicles: action.payload,
                requesting: false,
            };
        }
        case GET_DEPARTMENTS.REQUEST: {
            return { ...state, requesting: true };
        }
        case GET_DEPARTMENTS.FAIL: {
            return {
                ...state,
                departments: false,
                requesting: false,
            };
        }
        case GET_DEPARTMENTS.SUCCESS: {
            return {
                ...state,
                departments: action.payload,
                requesting: false,
            };
        }
        case GET_AREAS.REQUEST: {
            return { ...state, requesting: true };
        }
        case GET_AREAS.FAIL: {
            return {
                ...state,
                areas: false,
                requesting: false,
            };
        }
        case GET_AREAS.SUCCESS: {
            return {
                ...state,
                areas: action.payload,
                requesting: false,
            };
        }
        case GET_EQUIPMENT.REQUEST: {
            return { ...state, requesting: true };
        }
        case GET_EQUIPMENT.FAIL: {
            return {
                ...state,
                equipment: false,
                requesting: false,
            };
        }
        case GET_EQUIPMENT.SUCCESS: {
            return {
                ...state,
                equipment: action.payload,
                requesting: false,
            };
        }
        case GET_USERS.REQUEST: {
            return { ...state, usersRequesting: true };
        }
        case GET_USERS.FAIL: {
            return { ...state, users: false, usersRequesting: false };
        }
        case GET_USERS.SUCCESS: {
            return {
                ...state,
                users: action.payload,
                usersRequesting: false,
            };
        }
        case GET_PLANNER_DETAILS.REQUEST: {
            return { ...state, usersRequesting: true };
        }
        case GET_PLANNER_DETAILS.FAIL: {
            return { ...state, plannerDetails: false, usersRequesting: false };
        }
        case GET_PLANNER_DETAILS.SUCCESS: {
            return {
                ...state,
                plannerDetails: action.payload,
                usersRequesting: false,
            };
        }
        case GET_ROSTER_IS_LOCKED.REQUEST: {
            return { ...state, isLockedRequesting: true };
        }
        case GET_ROSTER_IS_LOCKED.FAIL: {
            return { ...state, isLocked: false, isLockedRequesting: false };
        }
        case GET_ROSTER_IS_LOCKED.SUCCESS: {
            return {
                ...state,
                isLocked: action.payload,
                isLockedRequesting: false,
            };
        }
        default: {
            return state;
        }
    }
};
